
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $f81b9c4eea42ecfe$exports = {};

$parcel$export($f81b9c4eea42ecfe$exports, "is-disabled", () => $f81b9c4eea42ecfe$export$d35bc1e505d1ebbf, (v) => $f81b9c4eea42ecfe$export$d35bc1e505d1ebbf = v);
$parcel$export($f81b9c4eea42ecfe$exports, "spectrum-Avatar", () => $f81b9c4eea42ecfe$export$2e049b8d031600fb, (v) => $f81b9c4eea42ecfe$export$2e049b8d031600fb = v);
var $f81b9c4eea42ecfe$export$d35bc1e505d1ebbf;
var $f81b9c4eea42ecfe$export$2e049b8d031600fb;
$f81b9c4eea42ecfe$export$d35bc1e505d1ebbf = `jilAbW_is-disabled`;
$f81b9c4eea42ecfe$export$2e049b8d031600fb = `jilAbW_spectrum-Avatar`;


export {$f81b9c4eea42ecfe$exports as default};
//# sourceMappingURL=avatar_vars_css.module.js.map
